import { Types } from '@fedsim/actions'
import { getId } from '@fedsim/helpers'
import { attr, many, Model } from 'redux-orm'

export const showFrequency = {
  weekly: 'weekly',
  monthly: 'monthly',
  yearly: 'yearly'
}

export class Show extends Model {
  static get fields() {
    return {
      id: attr(),

      name: attr({ getDefault: () => '' }),
      desc: attr({ getDefault: () => '' }),
      image: attr({ getDefault: () => '' }),

      color: attr({ getDefault: () => '' }),
      backgroundColor: attr({ getDefault: () => '' }),

      special: attr({ getDefault: () => false }),
      frequency: attr({ getDefault: () => showFrequency.weekly }),

      monthIndex: attr({ getDefault: () => false }),
      weekIndex: attr({ getDefault: () => false }),
      dayIndex: attr({ getDefault: () => 0 }),

      maxDuration: attr({ getDefault: () => 3600 }),
      entranceVideoUrl: attr({ getDefault: () => null }),

      minPoints: attr({ getDefault: () => 50 }),
      maxPoints: attr({ getDefault: () => 80 }),

      // avgs
      income: attr({ getDefault: () => 0 }),
      avgTicketPrice: attr({ getDefault: () => 0 }),
      avgMerchPrice: attr({ getDefault: () => 0 }),
      avgViewers: attr({ getDefault: () => 0 }),
      avgAttendance: attr({ getDefault: () => 0 }),

      // JOINS
      brandIds: many({
        to: 'Brand',
        as: 'brands',
        relatedName: 'ShowBrands'
      }),
      refereeIds: many({
        to: 'Wrestler',
        as: 'referees',
        relatedName: 'ShowReferees'
      }),
      interviewerIds: many({
        to: 'Wrestler',
        as: 'interviewers',
        relatedName: 'ShowInterviewers'
      }),
      commentatorIds: many({
        to: 'Wrestler',
        as: 'commentators',
        relatedName: 'ShowCommentators'
      }),
      authorityIds: many({
        to: 'Wrestler',
        as: 'authority',
        relatedName: 'ShowAuthority'
      })
    }
  }
  static reducer(action, Show, session) {
    let item
    switch (action.type) {
      case Types.RESET:
      case Types.RESET_SHOWS:
        session.Show.all()
          .toModelArray()
          .forEach(item => {
            item.delete()
          })
        break
      case Types.ADD_SHOW:
        Show.upsert({ id: getId(), ...action.payload })
        break

      case Types.UPDATE_SHOW:
        item = Show.withId(action.payload.id)
        item.update(action.payload)
        break
      case Types.GENERATE_SHOWS:
        action?.payload?.forEach(newItem => {
          session.Show.upsert(newItem)
        })
        break
      case Types.DELETE_SHOW: {
        Show.withId(action.payload.id).delete()
        break
      }
    }
  }
}

export default Show
